import React, { useState } from "react"

import { getMoment } from "utils"
import classes from "./DpFooter.module.scss"

const moment = getMoment()

const DpFooter = props => {
  const {
    type,
    timeRange,
    timeRangeStep,
    setTimeRangeStep,
    selectedDate,
    selectedTime,
    setOpenDatePicker,
    onChange,
    selectedRange
  } = props

  const [error, setError] = useState("")

  const handleConfirmRange = () => {
    const resultRange = [...selectedRange]

    if (!resultRange[1]) resultRange[1] = selectedRange[0]

    onChange([
      resultRange[0].toISOString(),
      resultRange[1].endOf("day").toISOString()
    ])

    setOpenDatePicker(false)
  }

  const handleConfirmTime = () => {
    onChange(`${selectedTime.hours}:${selectedTime.minutes}:00`)
  }

  const handleConfirmDate = () => {
    const resultDate = moment(selectedDate)

    type === "dateAndTimePicker" &&
      resultDate.set({
        hours: selectedTime.hours,
        minutes: selectedTime.minutes
      })

    onChange(resultDate.toISOString())

    setOpenDatePicker(false)
  }

  const handleTimeRange = () => {
    if (timeRangeStep === "start")
      return setTimeRangeStep("end")

    if ((Number(timeRange[0].hours) > Number(timeRange[1].hours))) {
      return setError("زمان شروع از زمان پایان بیشتر است")
    } else if (
      Number(timeRange[0].hours) === Number(timeRange[1].hours) &&
      Number(timeRange[0].minutes) > Number(timeRange[1].minutes)
    ) {
      return setError("زمان شروع از زمان پایان بیشتر است")
    }

    onChange([
      `${timeRange[0].hours}:${timeRange[0].minutes}:00`,
      `${timeRange[1].hours}:${timeRange[1].minutes}:00`
    ])

    setOpenDatePicker(false)
  }

  const handleConfirm = () => {
    if (type === "rangeDatePicker") {
      return handleConfirmRange()
    }

    if (type === "timePicker") {
      return handleConfirmTime()
    }

    handleConfirmDate()
  }

  return (
    <div className={classes["footer"]}>
      {
        !!error &&
        <div className={classes["error"]}>
          *{error}
        </div>
      }
      <button
        className={classes["close"]}
        onClick={() => setOpenDatePicker(false)}
      >
        بستن
      </button>
      {type === "rangeTimePicker" ?
        <button onClick={handleTimeRange}>
          {timeRangeStep === "start" ? "بعدی" : "تایید"}
        </button> :
        <button
          onClick={handleConfirm}
        >
          تایید
        </button>
      }
    </div>
  )
}

export default DpFooter